import type {LeadUpdateBody} from 'src/types/landing-page';

import type {Dispatch, ThunkAction, GetState} from 'src/reducers';
import {key, cached, fetching} from 'src/utils/redux';

// Const Defined Here
export const SAVE_ORIGINAL_LEAD_DATA = 'leads/lead-original-data';

// Defined Action Type Here
type SaveOriginalLeadDataAction = {
  type: typeof SAVE_ORIGINAL_LEAD_DATA;
  payload: LeadUpdateBody[];
};

// All The Actions here
export type LeadsActions = SaveOriginalLeadDataAction;

const saveOriginalLeadData = (
  payload: LeadUpdateBody[],
): SaveOriginalLeadDataAction => ({
  type: SAVE_ORIGINAL_LEAD_DATA,
  payload,
});

// Function to call Dispatch function from here
export const updateSavedOriginalLeadData =
  (dt: LeadUpdateBody[]): ThunkAction<unknown> =>
  (dispatch: Dispatch) =>
    // @ts-expect-error - TS2769 - No overload matches this call.
    dispatch(saveOriginalLeadData(dt));
